import React from 'react';

export default function PreviewCard({ imageUrl, title, domain, destinationUrl }) {
  let host = domain;
  if (!host && destinationUrl) {
    try {
      host = new URL(destinationUrl).hostname.replace(/^www\./, '');
    } catch (e) {
      host = '';
    }
  }

  return (
    <a
      href={destinationUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="block rounded-lg border border-gray-700/40 overflow-hidden hover:border-gray-600/60 transition-colors"
      aria-label={title || host || 'Open preview'}
    >
      <div className="w-full h-16 bg-gray-800/20 overflow-hidden">
        {imageUrl ? (
          <img src={imageUrl} alt={title || 'preview'} width="340" height="64" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-500">
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M3 10h18" />
            </svg>
          </div>
        )}
      </div>

      <div className="px-2 py-1 bg-gray-800/10 border-t border-gray-700/30">
        <div className="text-[10px] font-semibold text-fg truncate">{title}</div>
        {host && <div className="text-[9px] text-fg-muted truncate leading-none mt-0.5">{host}</div>}
      </div>
    </a>
  );
}
